import React from 'react';
import { PermissionWrapper } from '../../../components/accessControl/PermissionWrapper';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { CreateTagPage } from './CreateTagPage';

export const CreateTagContainer: React.FC = () => {
  return (
    <PermissionWrapper allowedPermissions={[ePermissions.TagEdit]}>
      <CreateTagPage />
    </PermissionWrapper>
  );
};
